import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store'
import PersonalizedCategories from './views/personalized/PersonalizedCategories.vue'
import PersonalizedTour from './views/personalized/PersonalizedTour.vue'
import PersonalizedEdit from './views/personalized/PersonalizedEdit.vue'
import ExploreCampus from './views/ExploreCampus.vue'
import CuratedTour from './views/CuratedTour.vue'
import Tour from './views/Tour.vue'
import NotFound from './views/NotFound.vue'
import Congratulations from './views/Congratulations.vue'
import PoiInformation from './views/poi/PoiInformation.vue'
import PoiDirections from './views/poi/PoiDirections.vue'
import PoiNotes from './views/poi/PoiNotes.vue'
import Notes from './views/Notes.vue'
import About from './views/About.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/error',
      component: NotFound
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/explore',
      name: 'ExploreCampus',
      component: ExploreCampus
    },
    {
      path: '/curated',
      name: 'CuratedTour',
      component: CuratedTour
    },
    {
      path: '/poi/:id',
      redirect: {
        name: 'PoiInformation'
      },
      meta: {
        block: 'Poi'
      },
      name: 'PoiView',
      component: () => import(/* webpackChunkName: "poiview" */ './views/poi/PoiView.vue'),
      children: [
        {
          path: 'info',
          name: 'PoiInformation',
          component: PoiInformation,
          meta: {
            block: 'Poi'
          }
        },
        {
          path: 'directions',
          name: 'PoiDirections',
          component: PoiDirections,
          meta: {
            block: 'Poi'
          }
        },
        {
          path: 'notes',
          name: 'PoiNotes',
          component: PoiNotes,
          meta: {
            block: 'Poi'
          }
        }
      ]
    },
    {
      path: '/curated/tour/:id',
      name: 'Tour',
      component: Tour,
      props: true
    },
    {
      path: '/personalized/categories',
      name: 'PersonalizedCategories',
      component: PersonalizedCategories
    },
    {
      path: '/personalized/categories/:category',
      name: 'PersonalizedEdit',
      component: PersonalizedEdit,
      props: true
    },
    {
      path: '/personalized/tour/',
      name: 'PersonalizedTour',
      component: PersonalizedTour
    },
    {
      path: '/congratulations',
      name: 'Congratulations',
      component: Congratulations
    },
    {
      path: '/notes',
      name: 'Notes',
      component: Notes
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})

// setting college id automatically before each request
router.beforeEach((to, from, next) => {
  if (to.params.college === undefined) {
    to.params.college = from.params.college
  }

  store.commit('history/pushEntry', to)

  next()
})

export default router
